
import React from "react";

const PaymentVerifyModal = ({
  open,
  onClose,
  paymentVerifyId,
  setPaymentVerifyId,
  paymentVerifyEmail,
  setPaymentVerifyEmail,
  errors,
  onSubmit,
}) => {
  if (!open) return null;

  return (
    <div className="modal fade d-block show" style={{ zIndex: 9 }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Payment Verify</h5>
            <button
              type="button"
              className="close"
              onClick={onClose}
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          {/* Body */}
          <div className="modal-body">
            {/* Payment ID */}
            <div className="d-flex mb-3">
              <h6 className="mb-0">Payment ID</h6>
            </div>
            <div className="btn-default mb-2 mr-1">
              <div className="form-group pos_relative">
                <input
                  type="text"
                  className={`form-control ${
                    errors.paymentVerifyId ? "red_border" : ""
                  }`}
                  placeholder="Enter your Payment ID"
                  value={paymentVerifyId}
                  onChange={(e) => setPaymentVerifyId(e.target.value)}
                />
                {errors.paymentVerifyId && (
                  <p className="text-danger pos_abos white_space">
                    {errors.paymentVerifyId}
                  </p>
                )}
              </div>
            </div>

            {/* Email ID */}
            <div className="d-flex mb-3">
              <h6 className="mb-0">Email ID</h6>
            </div>
            <div className="btn-default mb-2 mr-1">
              <div className="form-group pos_relative">
                <input
                  type="text"
                  className={`form-control ${
                    errors.paymentVerifyEmail ? "red_border" : ""
                  }`}
                  placeholder="Enter your Email ID"
                  value={paymentVerifyEmail}
                  onChange={(e) => setPaymentVerifyEmail(e.target.value)}
                  readOnly
                />
                {errors.paymentVerifyEmail && (
                  <p className="text-danger pos_abos white_space">
                    {errors.paymentVerifyEmail}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info btn-block saveand_proced_button"
              onClick={onSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentVerifyModal;